// extracted by mini-css-extract-plugin
export default {"searchBar":"GridSearchBar_searchBar__6XfyV","text":"GridSearchBar_text__0nwkT"};